import { render } from "./AdminEducationSections.vue?vue&type=template&id=4cf3b1b9&scoped=true&ts=true"
import script from "./AdminEducationSections.vue?vue&type=script&lang=ts"
export * from "./AdminEducationSections.vue?vue&type=script&lang=ts"

import "./AdminEducationSections.vue?vue&type=style&index=0&id=4cf3b1b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf3b1b9"]])

export default __exports__